import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-content',
    templateUrl: './detail-content.component.html',
    styleUrls: ['./detail-content.component.scss'],
    standalone: false,
})
export class DetailContentComponent {
}
